export default {
  computed: {
    limits() {
      return this.$store.getters.modelingSystemLimits
    },
    canCalculate() {
      //По задаче https://app.clickup.com/t/2k56163 снимаем проверку на оперативку
      //this.limits.memory.percent > this.limits.memory.thresholdw
      return this.limits.disk.percent > this.limits.disk.threshold
    }
  },

  beforeDestroy() {
    this.$store.commit('setModelingNeedSystemLimits', -1)
  },

  created() {
    this.$store.commit('setModelingNeedSystemLimits', 1)
  },

  mounted() {
    this.$store.dispatch('startModelingLimitsRegularUpd')
  },

  methods: {
    showCanCalculateNotification() {
      this.$store.commit('setApiErrorInfo', 'Превышены системные лимиты')
    },

    checkWorkspaceVerisonLimitReached() {
      if (this.$store.getters.wsLimitReached) {
        this.$ui.toast.show({ text: 'Достигнуто доступное количество версий рабочих пространств.', type: 'error', time: 5000 })
        return true
      }

      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/limits.js